/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService, NavigationService, UserService } from '../services';
import { Injectable } from '@angular/core';
import { ModulesEnum, OtherEnum, TokenStatus } from '../enums';

@Injectable()
export class AuthGuard {
    constructor(
        private api: ApiService,
        private navigationService: NavigationService,
        private router: Router,
        private userService: UserService
    ) {
    }

    /**
     * Can activate route.
     * @param _route - this needs to be here even if not being used.
     * @param state
     */
    public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        this.navigationService.history = state.url;
        if (this.userService.hasLocalStorage()) {
            if (this.userService.tokenStatus() === TokenStatus.OK
                || this.userService.tokenStatus() === TokenStatus.REFRESH
            ) {
                return this.checkHost().then(() => {
                    if (state.url === '/') {
                        this.redirectToUrl('overview');
                    }

                    return true;
                }, () => {
                    return false;
                });
            }
        }
        this.navigationService.redirectLocation = state.url;
        this.userService.logout();

        return false;
    }

    /**
     * Function used to ensure that we can still communicate with the host
     * Otherwise handle the situation.
     * @private
     */
    private checkHost(): any {
        return new Promise<void>((connected, disconnected) => {
            this.api.ping(OtherEnum.GET_PING, ModulesEnum.LOADBALANCER, 3000).subscribe({
                next: alive => {
                    if (alive) {
                        connected();
                    } else {
                        disconnected();
                    }
                }
            });
        });
    }

    /**
     * Redirect to supplied url.
     * @param url
     * @private
     */
    private redirectToUrl(url: string): void {
        const lbUser = JSON.parse(localStorage.getItem('lbUser'));
        const applianceId = lbUser?.applianceId;
        // allow for lb/list path
        this.router.navigateByUrl(`/lb/${applianceId}/` + url).then().catch();
    }
}
